import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const notify = inject(NotificationService);
  const token = auth.idToken;

  let request = req;
  if (token && req.url.includes('/api/')) {
    request = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) {
        notify.error('Network error: unable to reach the server. Please try again.');
      } else if (error.status === 503) {
        const detail = error.error?.detail || 'Database is starting up. Please wait 30 seconds and try again.';
        notify.error(detail);
      } else if (error.status === 504 || error.status === 408) {
        notify.error('Request timed out. The database may be waking up - please try again in a moment.');
      } else if (error.status >= 500) {
        const detail = error.error?.detail || 'An unexpected server error occurred.';
        notify.error(detail);
      }
      return throwError(() => error);
    })
  );
};
